import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork"; 
export const getVPList = createAsyncThunk(
  "/vplist/get",
  async (_, { rejectWithValue }) => {
    try {
      // authToken eklenecek cookie,local vs biryerden okunup
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/virtualpos/firmbanklist");
      if (isSuccess ) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e) {
      return rejectWithValue(e.data.message);
    }
  }
);

export const vpListSlice = createSlice({
  name: "vplist",
  initialState: {
    vpList: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.vpList = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getVPList.fulfilled, (state, { payload }) => {

      var resultList = [];

      for (let i = 0; i < payload.length; i++) {
        const element = payload[i];
        if (element?.vpList?.status) {
          resultList.push(element);
        }
      }
      for (let i = 0; i < payload.length; i++) {
        const element = payload[i];
        if (!element?.vpList?.status) {
          resultList.push(element);
        }
      }
      state.vpList = resultList;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });
    builder.addCase(getVPList.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      // state.errorMessage = payload.message;
    });
    builder.addCase(getVPList.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = vpListSlice.actions;

export const vpListSelector = (state) => state.vplist;

export const vpListReducer = vpListSlice.reducer;
